module.exports = __webpack_public_path__ + "img/Gorilla-Power-Logo-Template.jpg";